import { ResponseChartData } from "app/model/response-chart";
import moment from "moment";
import { Constant } from "app/constants/constant";
import i18n from "i18next";
import dayjs from "dayjs";

export class ChartUtil {
  static readonly seriesDefaultColorSet = [
    "#545CC1", "#4C96F9", "#44C5DB", "#FFBB24", "#FD6868", "#F779A6", "#576574",];

  static readonly monthToNumberArray = Array.from(
    { length: 12 },
    (_, i) => i + 1
  );
  static readonly monthOfYearInZeroNumberArray = [...this.monthToNumberArray].map(() => 0);

  static readonly hourOfDayNumberArray = Array.from(Array(24).keys());

  static readonly hourOfDayInZeroNumberArray = [...this.hourOfDayNumberArray].map(() => 0);

  static readonly dayOfMonthArray = (date: string) => {
    const y = dayjs(date).endOf("month").format("D");
    return Array.from({ length: Number(y) }, (_, i) => i + 1);
  };

  static readonly getDayOfMonthCategories = (date: string) => {
    const y = dayjs(date).endOf("month").format("D");
    return Array.from({ length: Number(y) }, (_, i) => `${i + 1}일`);
  };

  static readonly dayOfMonthInZeroNumberArray = (date: string) => {
    const y = dayjs(date).endOf("month").format("D");
    return Array.from({ length: Number(y) }, () => 0);
  }

  static readonly getMonthForCategories = () => {
    return Array.from({ length: 12 }, (_, i) => i + 1).map((v) => v + i18n.t("common.unit.month"));
  };

  static readonly daysOfMonth = (): string[] => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();

    const getDaysInMonth = (year: number, month: number): string[] => {
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      return Array.from({ length: daysInMonth }, (_, i) => `${i + 1}일`);
    };

    const currentMonthDays = getDaysInMonth(year, month);

    const previousMonthDays = getDaysInMonth(year, month - 1);

    return currentMonthDays.length > previousMonthDays.length
      ? currentMonthDays
      : previousMonthDays;
  };

  public static readonly defaultLoadingSpinner = (): string => {
    return `
      <div style="text-align: center;">
        <span style="font-size: 1rem;">불러오는 중...</span>
      </div>`;
  };

  static readonly setMissingMonthlyData = (
    itemData: ResponseChartData[],
    category?: string[]
  ) => {
    let result: number[] = [];
    if (itemData) {
      if (category) {
        result = category.map((v) => {
          const data = itemData.find(
            (f) => `${f.year}년 ${f.month}월` === v || `${f.month}월` === v
          );
          return data?.value ?? 0;
        });
      } else {
        result = Array.from({ length: 12 }, (_, i) => i + 1).map((v) => {
          const data = itemData.find((f) => f.month === v);
          return data?.value ?? 0;
        });
      }
    }
    return result;
  };

  static readonly getHourOfDayForCategory = () => {
    return Array.from(Array(24).keys()).map(
      (v) => v.toString().padStart(2, "0") + ":00"
    );
  };

  static readonly correctMissingDataByCategory = (
    searchType: string,
    itemData: any[],
    key: string,
    value: string,
    category: any[]
  ) => {
    const newItemData: any[] = [];
    if (category) {
      let searchKey: any;
      let data: any;
      let tmpValue = 0;
      category.forEach((x) => {
        searchKey = x.replace(/[^0-9]/g, "");

        if (itemData && Array.isArray(itemData) && itemData.length > 0) {
          if (searchType.toUpperCase() == "YEAR") {
            data = itemData?.find(
              (d: any) =>
                d[key] &&
                (d[key] === searchKey || d[key].substring(0, 4) === searchKey)
            );
          } else if (searchType.toUpperCase() == "MONTH") {
            if (searchKey.length === 5) {
              searchKey = "0" + searchKey.substring(4, 5);
            } else if (searchKey.length === 6) {
              searchKey = searchKey.substring(4, 6);
            } else if (searchKey.length === 1) {
              searchKey = "0" + searchKey;
            }
            data = itemData?.find(
              (d: any) => d[key] && d[key].substring(4, 6) === searchKey
            );
          } else if (searchType.toUpperCase() == "DAY") {
            if (searchKey.length === 6) {
              searchKey = "0" + searchKey.substring(5, 6);
            } else if (searchKey.length === 7) {
              searchKey = searchKey.substring(5, 7);
            } else if (searchKey.length === 1) {
              searchKey = "0" + searchKey;
            }
            data = itemData?.find(
              (d: any) => d[key] && d[key].substring(6, 8) === searchKey
            );
          } else {
            if (searchKey.length === 1) {
              searchKey = "0" + searchKey;
            }

            data = itemData?.find(
              (d: any) => d[key] && d[key].substring(8, 10) === searchKey
            );
          }

          if (data) {
            tmpValue = data[value];
          } else {
            tmpValue = 0;
          }
        } else {
          tmpValue = 0;
        }

        newItemData.push([x, tmpValue]);
      });
    }
    return newItemData;
  };

  static readonly correctMissingDataByCategory2 = (
    searchType: string,
    itemData: any[],
    key: string,
    value: string,
    category: any[]
  ) => {
    const newItemData: any[] = [];
    if (category) {
      let searchKey: any;
      let data: any;
      category.forEach((x) => {
        searchKey = x.replace(/[^0-9]/g, "");

        if (searchType.toUpperCase() == "YEAR") {
          data = itemData?.find(
            (d: any) =>
              d[key] &&
              (d[key] === searchKey || d[key].substring(0, 4) === searchKey)
          );
        } else if (searchType.toUpperCase() == "MONTH") {
          if (searchKey.length === 5) {
            searchKey = "0" + searchKey.substring(4, 5);
          } else if (searchKey.length === 6) {
            searchKey = searchKey.substring(4, 6);
          } else if (searchKey.length === 1) {
            searchKey = "0" + searchKey;
          }
          data = itemData?.find(
            (d: any) => d[key] && d[key].substring(4, 6) === searchKey
          );
        } else if (searchType.toUpperCase() == "DAY") {
          if (searchKey.length === 6) {
            searchKey = searchKey.substring(5, 6);
          } else if (searchKey.length === 7) {
            searchKey = searchKey.substring(5, 7);
          } else if (searchKey.length === 1) {
            searchKey = "0" + searchKey;
          }
          data = itemData?.find(
            (d: any) => d[key] && d[key].substring(6, 8) === searchKey
          );
        } else {
          if (searchKey.length === 1) {
            searchKey = "0" + searchKey;
          }
          data = itemData?.find(
            (d: any) => d[key] && d[key].substring(8, 10) === searchKey
          );
        }

        if (data) {
          newItemData.push(data[value]);
        } else {
          newItemData.push(0);
        }
      });
    }

    return newItemData;
  };

  static readonly getMonthRangeForCategory = (
    fromMonth: string,
    toMonth: string
  ) => {
    let monthArray = [];
    let from = moment(fromMonth, "YYYYMMDDHHmmss");
    let to = moment(toMonth, "YYYYMMDDHHmmss");

    if (from.isValid() && to.isValid()) {
      while (from.year() !== to.year() || from.month() !== to.month()) {
        monthArray.push(from.format("M월"));
        from.add(1, "month");
      }

      monthArray.push(from.format("M월"));
    }
    return monthArray;
  };

  static readonly getYearRangeForCategory = (
    fromYear: string,
    toYear: string
  ) => {
    let yearArray = [];
    let from = moment(fromYear, Constant.FORMAT_YMDHMS);
    let to = moment(toYear, Constant.FORMAT_YMDHMS);

    if (from.isValid() && to.isValid()) {
      while (from.year() !== to.year()) {
        yearArray.push(from.format("YYYY년"));
        from.add(1, "year");
      }

      yearArray.push(from.format("YYYY년"));
    }
    return yearArray;
  };

  static readonly getDateRangeForCategory = (
    fromDate: string,
    toDate: string
  ) => {
    let dateArray = [];
    let from = moment(fromDate, Constant.FORMAT_YMDHMS);
    let to = moment(toDate, Constant.FORMAT_YMDHMS);

    if (from.isValid() && to.isValid()) {
      while (
        from.year() !== to.year() ||
        from.month() !== to.month() ||
        from.date() !== to.date()
      ) {
        dateArray.push(from.format("D일"));
        from.add(1, "day");
      }

      dateArray.push(from.format("D일"));
    }
    return dateArray;
  };

  static readonly getHourRangeForCategory = () => {
    return Array.from(Array(24).keys()).map((m) => `${m}시`);
  };
}